import React from "react";
import logoDark from "../../assets/tronClubIconDark.png";
import logoLight from "../../assets/tronClubIconLight.png";
import { menus } from "../../utils/tools/menu";
import MenuAccordion from "./MenuAccordion";
import { removeLocalStorage } from "../../utils/function/localStorage";
import { useGetLoginUserQuery } from "../../Services/userApi";
const Sidebar = ({ sideBarShow,theme }) => {
  const handleLogout = () => {
    removeLocalStorage("tron_token");
  };
  // get user
  const { data } = useGetLoginUserQuery();
  return (
    <div className="tronliveClub_sidebar">
      <div className="tronliveClub_logo_container">
        <img
          src={theme === "dark" ? logoDark : logoLight}
          width="100%"
          alt="logo"
        />
      </div>
      <div className="tronliveClub_user_profile">
        <div className="tronliveClub_user_info">
          <h2>{data?.data?.name}</h2>
          <p>{data?.data?.email}</p>
        </div>
      </div>
      <div className="tronliveClub_sidebar_menu">
        <ul className="tronliveClub_sidebar_menu_lists">
          <MenuAccordion
            d={menus}
            sideBarShow={sideBarShow}
            logout={handleLogout}
            userRole={data?.data?.role}
          />
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
